import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Button, Modal } from '@wfp/ui';
import { iconCalendar } from '@wfp/icons';
import { useNavigate } from 'react-router-dom';

import { useDocId } from '../../hooks/home';

import './DocCalendar.scss';


export function DocCalendar() {
	const docId = useDocId();
	const navigate = useNavigate();
	const [value, setValue] = useState(new Date(docId));
	const [modalOpen, setModalOpen] = useState(false);

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	return (
		<>
			<Button kind="ghost" className="reset-font-size"
					icon={iconCalendar} iconDescription=" "
					onClick={() => setModalOpen(true)}
			/>
			{modalOpen && <Modal
				open
				modalHeading="Jump to date"
				primaryButtonText="Confirm"
				secondaryButtonText="Cancel"
				onRequestSubmit={() => {
					const d = new Date(value);
					d.setMinutes(d.getMinutes() - d.getTimezoneOffset());  // adjust for non UTC timezones
					const id = d.toISOString().substring(0, 10);  // yyyy-mm-dd
					navigate(`/${id}`);
					setModalOpen(false);
				}}
				onRequestClose={() => {
					setModalOpen(false);
					setValue(new Date(docId));  // reset value for next open
				}}>

				<Calendar
					value={value}
					onChange={setValue}
					minDate={new Date(2001, 1, 1)}
					maxDate={tomorrow}
				/>
			</Modal>}
		</>
	);
}
